import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService,JwtService,User } from '../../shared';
import {environment} from '../../../environments/environment'
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';


@Component({
  templateUrl: 'document.component.html',
  styleUrls: ['./style.component.css']
  
  
})

export class DocumentComponent implements OnInit {
  imageURL: string = environment.cloudeImageURL;
  public data: Object;
  modalRef: BsModalRef;
  resp:any;
  url:any;
  CurrentUser:User;
  apiurl:any = environment.api_url;
  document:any;
  constructor(
    private route:ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private userService:UserService,
    private jwtService: JwtService
    
  ) {
    
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template,{backdrop: 'static'});
  }
  
  
  ngOnInit() {
    
  //this.jwtService.getworkflow()  
  
  this.userService.currentUser.subscribe(
    (userData) => {
      this.CurrentUser = userData;
    }
  )
  if(this.CurrentUser.item.hostModel=="CLOUD")
  this.imageURL = environment.cloudeImageURL;
else   
  this.imageURL = environment.vmImageURL;

  if(this.route.snapshot.url[0].path != 'assessment'){
    this.CurrentUser.operationStatus = ''
  }
  this.userService.PUser.subscribe(
    (puserData) => {
      this.resp = puserData;
         
    }
  )
  // this.userService.getdocument(window.localStorage['Puser'])
  // .subscribe(
  //   data => {
  //      //////console.log(data);
  //     if(data.length !==0){
  //     this.document = data;
     
  //      //////console.log(this.document);
  //   }
  //     else{
  //     this.document = null
  //     //////console.log(this.document);
  //   }
  //   }
    
  // ); 
  }
 
  imgadata(d){
//////console.log(d);
this.url=d;

  }
}
  

   
 
  

